import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/layers.css'; // layer order — must precede the kit (see file header)
import '@ofself/shell/styles.css';
import './styles/index.css';
import App from './App';
// The app's shell seam (accent + panel reconciliation) — loaded last so it wins
// ties over both index.css and the kit's CSS (which rides in with the shell).
import './shell-app.css';

// Light mode only — no theme attribute needed.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
